export default __webpack_public_path__ + "static/media/fuel-tank.cad02c8d.png";